// Edit patient form



  
		

$(document).ready(function() {

	
	var addyPt = new AddyComplete(document.getElementById("address1"));
 
	addyPt.fields = {
			address1: document.getElementById("address1"),
			address2: document.getElementById("address2"),
			suburb: document.getElementById("suburb"),
			city: document.getElementById("city"),
			postcode: document.getElementById("postCode")
	};	 
			
	var addyEmp = new AddyComplete(document.getElementById("employer-address1"));

	addyEmp.fields = {
			address1: document.getElementById("employer-address1"),
			address2: document.getElementById("employer-address2"),
			suburb: document.getElementById("employer-suburb"),
			city: document.getElementById("employer-city"),
			postcode: document.getElementById("employer-postCode")
	};		


	$('#ethnicity').change(function() {
    	if ($(this).val() === "21"){
    		$('#ethnicityOtherGroup').collapse('show');
    	} else {
    		$('#ethnicityOtherGroup').collapse('hide');
    		$('#ethnicityOther').val('');
    	}
	});
	
    if($('#radioEmploymentTrue').is(':checked')){ 

        $('.employed').collapse('show');
        $('.paid').show();
        $('.unpaid').hide();
    } 
    
    if($('#radioEmploymentFalse').is(':checked')){ 

        $('.employed').collapse('hide');
        $('.paid').hide();
        $('.unpaid').show();	
    }
	
    $("#occupationUnpaid option[value='']").remove();
    $('#occupationUnpaid').prepend($('<option>', {
        value: "",
        text: "-please select-"
    }));

    
//    $("#dob-day option[value='']").remove();
//    $('#dob-day').prepend($('<option>', {
//        value: "",
//        text: "-day-"
//    }));
//    if ($('#dob-day').val())
// 
//
//    $("#dob-month option[value='']").remove();
//    $('#dob-month').prepend($('<option>', {
//        value: "",
//        text: "-month-"
//    }));
//
//
//    $("#dob-year option[value='']").remove();
//    $('#dob-year').prepend($('<option>', {
//        value: "",
//        text: "-year-"
//    }));
   
    
    $("#status option[value='']").remove();
    $('#status').prepend($('<option>', {
        value: "",
        text: "-please select-"
    }));

    
    $("#workType option[value='']").remove();
    $('#workType').prepend($('<option>', {
        value: "",
        text: "-please select-"
    }));

    
    $("#ethnicity option[value='']").remove();
    $('#ethnicity').prepend($('<option>', {
        value: "",
        text: "-please select-"
    }));

   
  if($('#radioEmploymentTrue').prop('checked') == true){
//      $('.employed').collapse('show');
      $('.paid').show();
      $('.unpaid').hide();
  } else if($('#radioEmploymentFalse').prop('checked') == true){
//	  $('.employed').collapse('hide');
      $('.paid').hide();
      $('.unpaid').show();
	} else {
//		$('.employed').collapse('hide');
	      $('.paid').hide();
	      $('.unpaid').hide();	
	}

  
  if($('#radioSportingTrue').prop('checked') == true){

      $('#sport-group').collapse('show');

  } else {
  	   $('#sport-group').collapse('hide');
  }


//    $('#deviceEmail').val($("#device option:selected").text());

    $('#dob-day').change(function() {
      
        $('#dateOfBirth').val($('#dob-year').val() + "-" + $('#dob-month').val() + "-" + $('#dob-day').val());
    });

    $('#dob-month').change(function() {
     
        $('#dateOfBirth').val($('#dob-year').val() + "-" + $('#dob-month').val() + "-" + $('#dob-day').val());

    });

    $('#dob-year').change(function() {
      
        $('#dateOfBirth').val($('#dob-year').val() + "-" + $('#dob-month').val() + "-" + $('#dob-day').val());

    });

    $('#occupationUnpaid').change(function(e) {
    	$('#occupationid').val($('#occupationUnpaid').val());
    });    
    




    $('#add-phone').click( function(e) {
    	e.stopPropagation();
    	if (!RC.getPhone()){
    		RC.phone = 0;
    	}
    	RC.phone = RC.getPhone() + 1;
        var i = RC.getPhone();
        $('#phone-table > tbody:last-child').append('<tr class="row"><td class="col-sm-5">'+
				
                '<input class="form-control pms-field phone-table" type="text" id="phoneNumber' + i + '" name="phones[' + i + '][phoneNumber]" placeholder="Phone Number"/>' +
                '</td>' +
                '<td class="col-sm-5"> ' +
            	'<input type="hidden" name="phones[' + i + '][id]"  id="phoneId' + i + '" /> ' +
    			'<input type="hidden" name="phones[' + i + '][uuid]"   id="phoneUUID' + i + '" />' +
            	'<div > ' +
				'<select class="form-control phone-field pms-field phone-table" id="typeSelect'+i+'" name="phones['+i+'][phoneType]">' +
				' <option   value="mobilePhone"  >Mobile</option> '+ 
				' <option   value="homePhone"  >Home</option> '+ 
				' <option   value="workPhone"   >Work</option> '+ 
				'</select> ' + 
				'</div>	'+
				'</div>	'+
				'</td><td class="col-sm-2"> <span class="phone-remove mr-3"><i class="fas fa-minus-circle text-danger"></i></span>' +               
                '</td></tr>   ');

    });
    
    $('#phone-table').on("click", ".phone-remove", function(e) {
//        var rowI = $(this).closest('tr').index();
        $(this).closest('tr').remove();
    });
    
    
  
 
    
    $('.occupationOtherGroup').hide();
    


    
    $("#occupation").autocomplete({
        minLength: 3,
        delay: 500,

        source: function(request, response) {
            $.getJSON("/occupations", request, function(result) {
                response($.map(result, function(item) {
                    return {
                    	
                        // following property gets displayed in drop down
                        label: item.descriptionSuggestion,
                        // following property gets entered in the textbox
                        value: item.codeDescription,
                        id: item.id
                    };
                }));
            });
        },
        change: function(event, ui) {
            if (ui.item == null) {
            	$('#occupationid').val('999');
            }
        },
        //define select handler
        select: function(event, ui) {
            if (ui.item) {
                $('#occupationid').val(ui.item.id);
            }
        }
    });



    $('#status').change(function() {
        if ($('#status').val() === "3") {
            set_self_as_employer();
            $('.optionalEmployer').remove();
        } else  if ($('#status').val() === "2") {
       
        	$('.optionalEmployer').remove();
        	$('#employer').after('<small  class="form-text text-muted optionalEmployer">Optional</small>');
        	$('#employer-address-group').after('<small  class="form-text text-muted offset-sm-3 optionalEmployer">Optional</small>');
        } else  if ($('#status').val() === "4") {
          $('.occupationOtherGroup').show();
          $('.optionalEmployer').remove();
          $('#employer').after('<small  class="form-text text-muted optionalEmployer">Optional</small>');
      	$('#employer-address-group').after('<small  class="form-text text-muted offset-sm-3 optionalEmployer">Optional</small>');
      } else {
          $('.occupationOtherGroup').hide();
          $('#occupationOther').val('');
          $('.optionalEmployer').remove();
      }

  });

     
    $('#radioEmploymentTrue').change(function() {
  
        $('#occupationUnpaid').val('');
        $('#occupationid').val('');
        $('#status').val('');
        $('#workType').val('');
        $('#employer').val('');
        $('#employer-address1').val('');
        $('#employer-address2').val('');
        $('#employer-city').val('');
        $('#employer-postCode').val('');
        $('#employer-suburb').val('');
        $('.employed').collapse('show');
        $('#edit-patient-form').find('input[id="employer-radioHome"]').click();
        $('#employer-country').val('New Zealand');
        $('.paid').show();
        $('.unpaid').hide();
      
    });

 // need to set occ etc val to ''
    $('#radioEmploymentFalse').change(function() {
      
                $('#occupationUnpaid').val('');
        $('#occupationid').val('');
        $('#status').val('');
        $('#workType').val('');
        $('#employer').val('');
        $('#employer-address1').val('');
        $('#employer-address2').val('');
        $('#employer-city').val('');
        $('#employer-postCode').val('');
        $('#employer-suburb').val('');
      $('.employed').collapse('hide');
      $('input[name="employer[address][type]"]').prop('checked', false);
      $('#employer-country').val('');
        $('.paid').hide();
        $('.unpaid').show();
     
    });
    
    $('#radioSportingTrue').change(function() {

        $('#sport-group').collapse('show');

    });

    $('#radioSportingFalse').change(function() {
  
        $('#sport-group').collapse('hide');
        $('#sportid').val('');
        $('#sport').val('');
    });    

 



    /*
     * Form validation
     */

    // claim form
    jQuery.validator.addMethod("minDateOfBirth", function(value, element) {
        var now = new Date();
        var myDate = new Date(value);
        myDate.setHours(0);
        return this.optional(element) || myDate <= now;
    });
    


    // validate patient form 
    $('#edit-patient-form').validate({
    	errorClass: "is-invalid text-danger",
    	focusInvalid: false,
        rules: {
//        	ignore: ":hidden:not(#dateOfBirth)",

        	firstName : {
        		required : true
        	},
        	surname: {
        		required : true
        	},
        	"dob-day": {
        		required : true
        	},
        	"dob-month": {
        		required : true
        	},
        	"dob-year": {
        		required : true
        	},
            dob: {
                required: true,
                date: true,
                minDateOfBirth: true
            },        	
        	gender: {
        		required: true
        	},
        	"address[type]" : {
        		required: true
        	},
        	"address[line1]": {
        		required: true
        	},
        	"address[city]": {
        		required: true
        	},
        	"address[postCode]": {
        		required: true
        	},        	
        	"address[country]": {
        		required: true
        	},
        	"ethnicity[id]": {
        		required: true
        	},
        	inPaidEmployment : {
        		required: true
        	},
        	"occupationText" : {
        		required : true// '#radioEmploymentTrue:checked' 
        	},
        	"occupationUnpaidText" : {
        		required :  '#radioEmploymentFalse:checked' 
        	},        	
        	"phones[0][phoneType]" : {
        		required: true
        	},
        	"phones[0][phoneNumber]" : {
        		required: true
        	},
        	"employmentStatus[id]" : {
        		required: '#radioEmploymentTrue:checked' 
        	},
        	"otherEmployment" : { 
        		required: function(element){
        	
                    return $("#status option:selected").val() == 4;
                }
        	},
        	"workType[id]" : {
        		required: '#radioEmploymentTrue:checked'
        	},
        	"employer[employerName]" : {
        		required: function(element){
                	
                    if ( $("#status option:selected").val() == 1 &&  $("#radioWorkTrue").prop('checked')){
                    	return true;
                    } else {
                    	return false;
                    }
                }
        	},
        	"employer[address][type]" : {
        		required:  function(element){
                	
        			 if ( $("#status option:selected").val() == 1 &&  $("#radioWorkTrue").prop('checked')){
                    	return true;
                    } else {
                    	return false;
                    }
                }
                
        	},
        	"employer[address][line1]" : {
        		required: function(element){
                	
        			 if ( $("#status option:selected").val() == 1 &&  $("#radioWorkTrue").prop('checked')){
                    	return true;
                    } else {
                    	return false;
                    }
                }
        	},
        	"employer[address][city]" : {
        		required: function(element){
                	
        			 if ( $("#status option:selected").val() == 1 &&  $("#radioWorkTrue").prop('checked')){
                    	return true;
                    } else {
                    	return false;
                    }
                }
        	},  
        	"employer[address][postCode]" : {
        		required: function(element){
                	
        			 if ( $("#status option:selected").val() == 1 &&  $("#radioWorkTrue").prop('checked')){
                    	return true;
                    } else {
                    	return false;
                    }
                }
        	},
        	"employer[address][country]" : {
        		required: function(element){
                	
        			 if ( $("#status option:selected").val() == 1 &&  $("#radioWorkTrue").prop('checked')){
                    	return true;
                    } else {
                    	return false;
                    }
                }
        	}     	
        	

        },

        messages: {
            dob: {
                required: "Please supply a date of birth",
                minlength: "Please enter a valid date",
                minDate: "Date must be today or earlier"
            },
        	"address[type]" : {
        		required: "Address type is required"
        	},
        	"address[line1]": {
        		required: "Address line1 is required"
        	},
        	"address[city]": {
        		required: "Address city is required"
        	},
        	"address[postCode]": {
        		required:"Address postcode is required"
        	},        	
        	"address[country]" : {
        		required: "Address country is required"
        	},
        	"employer[address][type]" : {
        		required: "Address type is required"
        	},
        	"employer[address][line1]": {
        		required: "Address line1 is required"
        	},
        	"employer[address][city]": {
        		required: "Address city is required"
        	},
        	"employer[address][postCode]": {
        		required:"Address postcode is required"
        	},        	
        	"employer[address][country]" : {
        		required: "Address country is required"
        	},
        	"employer[employerName]" : {
        		required: "Employer is required, if accident is work related"
        	},

        },
        invalidHandler: function(form, validator) {

            if (!validator.numberOfInvalids())
                return;

            $('.feedback').append('<div class="alert alert-danger alert-dismissible fade show" role="alert"> <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> <h4 class="text-danger">Patient Form Errors</h4> Please fix errors and resubmit</div>');
            setTimeout(function() {
                $(".alert-dismissible").alert('close');
            }, 6000);

        },  
        errorElement: "div",
        errorPlacement: function(error, element) {
            // Add the `help-block` class to the error element
            error.addClass("form-control-feedback");
            error.insertAfter($('.save-submit'));
            if ($(element).prop("type") === "checkbox") {
                error.insertAfter($(element).parent("label"));
            } else if ($(element).hasClass("phone-field")) {
            
                error.insertAfter( $(element).closest('div').parent('div'));
            }  else if ($(element).prop("type") === "select") {
            
                error.insertAfter( $(element));
            }
            else if ($(element).prop("type") === "radio") {
            
                error.insertAfter( $(element).closest('div').next('div'));
            } else if($(element).hasClass('address')){
//            	error.addClass("offset-sm-3");
            	 error.appendTo( $('.address-error'));
        	} else if($(element).hasClass('employer-address')){
//            	error.addClass("offset-sm-3");
           	 error.appendTo( $('.employer-address-error'));
        	} else {
        		  error.insertAfter($(element));
                error.insertAfter($(element).next());
            }
        },
        highlight: function(element, errorClass, validClass) {
        	 $(element).addClass(errorClass);
        	if($(element).hasClass('code-element')){
        		$(element).parents(".code-row").addClass("text-danger");
        	} else if($(element).hasClass('address')){
        		$(element).parents(".input-group").addClass("text-danger");

        	} else {
  			 
		      $(element).parents(".form-group").addClass("text-danger");
        	}

            
        },
        unhighlight: function(element, errorClass, validClass) {
        	$(element).removeClass(errorClass);
            $(element).parents(".form-group").removeClass("text-danger");
            $(element).parents(".code-row").removeClass("text-danger");
            $(element).parents('.input-group').removeClass("text-danger");

        }
    });

	

});




function set_self_as_employer(){
	$('#employer').val('Self');
	$('#employer-radioHome').prop('checked', true);
	$('#employer-address1').val($('#address1').val());
	$('#employer-address2').val($('#address2').val());
	$('#employer-suburb').val($('#suburb').val());
	$('#employer-city').val($('#city').val());
	$('#employer-postCode').val($('#postCode').val());
}





function edit_patient_json(patientData) {
    //	var userDeviceId = patientData.device;

    if(!patientData.occupation.id){
    	delete patientData.occupation;
    }
    if (patientData.occupation && patientData.occupation.id === '999'){
    	delete patientData.occupation;
    	patientData.pmsOccupation = $('#occupation').val();
    }
    if(!patientData.workType.id){
    	delete patientData.workType;
    }
    if(!patientData.employmentStatus.id){
    	delete patientData.employmentStatus;
    }
    if(!patientData.ethnicity.id){
    	delete patientData.ethnicity;
    }
    
	if(patientData.phones){
		patientData.phones = $.grep(patientData.phones,function(n){ return n == 0 || n ;});
	}

//    delete patientData['email'];
//    patientData.ethnicity = null;
//    patientData.employer = null;
//    patientData.employerLocation = null;
//    patientData.occupation = null;
//    patientData.dateOfBirth = patientData.dob1 + '-' + patientData.dob2 + '-' + patientData.dob3;
//    delete patientData.dob1;
//    delete patientData.dob2;
//    delete patientData.dob3;
//    delete patientData.clientEdit;
//    delete patientData.patientClaimCompletedId;
    return patientData;
}








